import { render } from "./OrderServiceSearch.vue?vue&type=template&id=706dcf64&scoped=true"
import script from "./OrderServiceSearch.vue?vue&type=script&lang=js"
export * from "./OrderServiceSearch.vue?vue&type=script&lang=js"

import "@/assets/css/table-resp.css?vue&type=style&index=0&id=706dcf64&scoped=true&lang=css"
import "./OrderServiceSearch.vue?vue&type=style&index=1&id=706dcf64&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706dcf64"]])

export default __exports__